// extracted by mini-css-extract-plugin
module.exports = {"only-for-screen-reader":"only-for-screen-reader__igfVW"};